import { Search } from 'blaze-ui/icons'
import Styles from './SearchField.module.scss'

import { SearchFieldProps } from './Types'
import { Input } from 'almanac-ui/TextInputField/Input'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

const SearchField = ({ placeholder = 'Search', onChange, value }: SearchFieldProps) => {
  const { isMobile } = useResponsiveDesign()

  return (
    <div className={Styles.searchField}>
      <Search />
      <Input
        className={Styles.searchInput}
        name="search"
        autoFocus={!isMobile}
        id="mediaUploadSearchForm"
        type="text"
        value={value}
        onChange={(e) => onChange(e.currentTarget.value)}
        placeholder={placeholder}
        autoComplete="off"
        aria-label="Search Form Input"
        withBorder={false}
      />
    </div>
  )
}

export { SearchField }
